import {
  getAhaBridge,
  type AhaBridgeSaveUrlOptions
} from '@/app/bridge/ahaBridge';

type SaveBlobWithNativeAppOptions = {
  blob: Blob;
  fileName: string;
  mimeType?: string;
  mediaKind?: 'image' | 'video' | 'file';
  saveToPhotos?: boolean;
};

type NativeSaveResult = {
  method: 'native';
  canceled?: boolean;
};

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }
      reject(new Error('Unable to read download file.'));
    };
    reader.onerror = () =>
      reject(reader.error || new Error('Unable to read download file.'));
    reader.readAsDataURL(blob);
  });
}

export async function saveBlobWithNativeApp({
  blob,
  fileName,
  mimeType,
  mediaKind,
  saveToPhotos
}: SaveBlobWithNativeAppOptions): Promise<NativeSaveResult | null> {
  const bridge = getAhaBridge();
  const dataUrl = await blobToDataUrl(blob);
  const result = await bridge.file.saveFile({
    dataUrl,
    fileName,
    mimeType: mimeType || blob.type || 'application/octet-stream',
    mediaKind,
    saveToPhotos
  });
  if (result) return { method: 'native', canceled: result.canceled };

  if (saveToPhotos) {
    const imageResult = await bridge.file.saveImage({
      dataUrl,
      fileName
    });
    if (imageResult) return { method: 'native' };
  }

  return null;
}

export async function saveUrlWithNativeApp(
  options: AhaBridgeSaveUrlOptions
): Promise<NativeSaveResult | null> {
  const result = await getAhaBridge().file.saveUrl(options);
  if (!result) return null;
  return { method: 'native', canceled: result.canceled };
}
